import { DateRangePicker, InputWithLabel } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DateRangePickerOption = ({
  startDate,
  endDate,
  onChangeDate,
  inputValues,
  handleChangeInputDate,
  minDate,
  maxDate,
}) => {
  return (
    <Styles.DateRangeContainer>
      <DateRangePicker
        startDate={startDate}
        endDate={endDate}
        onChange={onChangeDate}
        minDate={minDate}
        maxDate={maxDate}
      />
      <Styles.InputsDateRangeContainer>
        <InputWithLabel
          value={inputValues?.startDate}
          placeholder={'dd/mm/yyyy'}
          onChange={event => handleChangeInputDate(event, 'startDate')}
        />
        -
        <InputWithLabel
          value={inputValues?.endDate}
          placeholder={'dd/mm/yyyy'}
          onChange={event => handleChangeInputDate(event, 'endDate')}
        />
      </Styles.InputsDateRangeContainer>
    </Styles.DateRangeContainer>
  )
}

export default DateRangePickerOption
